export default __webpack_public_path__ + "static/media/policy-title.eaf834cd.png";